import { createSelector } from 'reselect'

import { pendingSelector } from 'wordpress/selectors'
import { onStreetSchema, contentSchema } from 'wordpress/schemas'
import { createDenormalizedSelector } from 'entities/selectors'

export const idSelector = (state, props) => props.id
export const locationSlugSelector = (state, props) => props.match.params.slug

const normalizedLocationsSelector = state => state.onStreet
export const locationsSelector = createDenormalizedSelector(normalizedLocationsSelector, [onStreetSchema])
export const locationsPendingSelector = pendingSelector('locations')

export const locationBySlugSelector = createDenormalizedSelector(locationSlugSelector, onStreetSchema)

export const pageIdSelector = (state, props) => props.pageId
export const tabContentSelector = createDenormalizedSelector(pageIdSelector, contentSchema)

export const activeTabSelector = createSelector(locationBySlugSelector, tabContentSelector, (location, tab) =>
    tab ? location.tabs.find(({ page }) => page === tab.id) : null
)

const locationBackgroundSelector = createSelector(locationBySlugSelector, location =>
    location ? location.background : null
)

const locationsBackgroundSelector = createSelector(
    locationsSelector,
    locations => (locations.filter(location => location.background).shift() || {}).background
)

export const backgroundSelector = createSelector(
    locationBackgroundSelector,
    locationsBackgroundSelector,
    (locationBackground, locationsBackground) => locationBackground || locationsBackground
)
